import { Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { ErrorPageComponent } from '@shared/pages/error-page/error-page.component';

export const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'groups',
    },
    {
        path: 'groups',
        canActivateChild: [AuthGuard],
        data: {
            breadcrumb: 'Groups',
        },
        loadChildren: () => import('./core/routes/groups.routes').then(m => m.groupsRoutes),
    },
    {
        path: 'tl-hub',
        canActivateChild: [AuthGuard],
        data: {
            breadcrumb: 'tick@lab',
        },
        loadChildren: () => import('./core/routes/ticket-lab.routes').then(m => m.ticketLabRoutes),
    },
    {
        path: 'error',
        canActivate: [AuthGuard],
        component: ErrorPageComponent,
        data: {
            breadcrumb: null,
        },
    },
    {
        path: '**',
        redirectTo: 'groups',
    },
];
